import React from 'react';

import cs from 'classnames';

import Icon from '../Icon/Icon';

import BreadcrumbSkeleton from './components/BreadcrumbSkeleton';

const Breadcrumb = ({
  className,
  breadcrumb,
  textClassName,
  hasBackButton,
  lockNext,
  splitType = 'arrow',
  trimSteps = false,
  data,
  loading,
  activeClassName = 'text-neutral-800 font-medium',
  disableClick,
  noBrackets
}) => {
  return (
    <div
      className={cs('flex w-full items-center gap-2 overflow-x-auto overflow-y-hidden', className)}>
      {loading ? (
        <BreadcrumbSkeleton
          stepsLength={breadcrumb.steps.length}
          hasBackButton={hasBackButton}
          splitType={splitType}
          className={textClassName}
        />
      ) : (
        breadcrumb.steps.length > 0 && (
          <>
            {hasBackButton && breadcrumb.step > 0 && (
              <Icon
                className="cursor-pointer"
                onClick={() =>
                  breadcrumb.step > 0 && typeof breadcrumb.goBack === 'function'
                    ? breadcrumb.goBack(!trimSteps)
                    : breadcrumb.setStep((s) => s - 1)
                }
                icon="arrow-left-linear"
                color="neutral"
              />
            )}
            {breadcrumb.steps.map((s, index) => (
              <React.Fragment key={index}>
                <div
                  data-qa={`breadcrumb-step-${index}`}
                  className={cs(
                    index === breadcrumb.step ? activeClassName : 'text-neutral-600',
                    'cursor-pointer whitespace-nowrap text-sm',
                    textClassName
                  )}
                  onClick={() => {
                    if (disableClick) return;
                    if ((lockNext && index >= breadcrumb.step) || s?.locked) return;
                    if (!trimSteps) {
                      breadcrumb.setStep(index);
                    } else {
                      breadcrumb.setStepWithTrim(index);
                    }
                  }}>
                  {s?.title || s?.name}
                  {typeof s?.label === 'function' ? (
                    s?.label(data) ? (
                      <span className="text-sm text-neutral-800">
                        {' '}
                        {noBrackets ? s?.label(data) : `(${s?.label(data)})`}
                      </span>
                    ) : null
                  ) : s?.label ? (
                    <span className="text-sm text-neutral-800">
                      {' '}
                      {noBrackets ? s?.label : `(${s?.label})`}
                    </span>
                  ) : null}
                </div>
                {index !== breadcrumb.steps.length - 1 &&
                  (splitType === 'arrow' ? (
                    <Icon icon="chevron-right-linear" color="neutral" size="sm" />
                  ) : (
                    <p className={cs('!text-neutral-600 font-regular text-sm', textClassName)}>/</p>
                  ))}
              </React.Fragment>
            ))}
          </>
        )
      )}
    </div>
  );
};

export default Breadcrumb;
